/** Shared kiosk idle contract — keep page timers thin; test this, not JSX. */

export const KIOSK_IDLE_MS = 90_000;

export type KioskIdleAction = 'lock' | 'resetHome' | 'none';

/**
 * When unlocked, always full-lock on idle — including on the home step —
 * so the next walk-up cannot checkout/return without VID+PIN.
 */
export function resolveKioskIdleAction(opts: {
  unlocked: boolean;
  step: string;
}): KioskIdleAction {
  if (opts.unlocked) return 'lock';
  if (opts.step !== 'home') return 'resetHome';
  return 'none';
}
